import { createAction, props } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../core/models/generic-models';
import { IBanks } from '../models/banks.model';

export const loadBanks = createAction('[Banks] Load Banks', props<{ request: string }>());

export const loadBanksSuccess = createAction('[Banks] Load Bankss Success', props<{ response: IBanks[] }>());

export const loadBanksFailure = createAction('[Banks] Load Bankss Failure', props<{ error: IGenericError<ErrorResponse> }>());
